<div [hidden]="!(isPatientAppReady$ | async)">
	<div class="title">{{ 'IntuitivePatient.PatientDetails' | translate }}</div>
	<tlk-card>
		<div tlkCardContent class="patient-details-content" [ngClass]="'patient-display-mode-' + (patientDisplayMode$ | async)">
			<rx-patient></rx-patient>
		</div>
		<div tlkCardFooter class="footer" [ngClass]="'patient-footer-display-mode-' + (patientDisplayMode$ | async)">
			<button tlkButton (click)="onCreateClick()" [disabled]="(isValidToSave$ | async) === false || isSaving" class="save-button">
				<tlk-loading-spinner *ngIf="isSaving" [size]="32" class="button-spinner"></tlk-loading-spinner>
				<span *ngIf="!isSaving">
					{{ (isNewPatient$ | async) ? ('IntuitivePatient.Create' | translate) : ('IntuitivePatient.Next' | translate) }}
				</span>
			</button>
		</div>
	</tlk-card>
</div>
